module.exports = __webpack_public_path__ + "static/media/lato-regular.7f690e50.ttf";